import { render, staticRenderFns } from "./editClassification.vue?vue&type=template&id=5f6d7348&scoped=true"
import script from "./editClassification.vue?vue&type=script&lang=js"
export * from "./editClassification.vue?vue&type=script&lang=js"
import style0 from "./editClassification.vue?vue&type=style&index=0&id=5f6d7348&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6d7348",
  null
  
)

export default component.exports